import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, PackageX, Clock, CheckCircle2, MessageSquare, Send, User, Store } from 'lucide-react';
import { useNavigation } from '../context/NavigationContext';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function VendorDisputeDetailScreen() {
  const {
    currentParams,
    goBack
  } = useNavigation();
  const [reply, setReply] = useState('');
  const [loading, setLoading] = useState(false);
  const disputeId = currentParams?.disputeId || 'DSP-001';
  // Mock dispute data
  const dispute = {
    id: disputeId,
    orderId: 'VO-002',
    buyerName: 'Jane Smith',
    reason: 'Defective Product',
    date: '2024-03-15',
    status: 'Open',
    priority: 'High',
    messages: [{
      id: 'm1',
      sender: 'buyer',
      name: 'Jane Smith',
      text: 'The screen of the phone has a green line on the right side. I just opened it today. I want a replacement or refund.',
      time: 'Mar 15, 10:30 AM'
    }, {
      id: 'm2',
      sender: 'vendor',
      name: 'Kingsley Electronics',
      text: 'We apologize for the inconvenience. Could you please provide a picture of the defect so we can process the return?',
      time: 'Mar 15, 11:15 AM'
    }, {
      id: 'm3',
      sender: 'buyer',
      name: 'Jane Smith',
      text: 'I have attached the pictures. Please check.',
      time: 'Mar 15, 11:45 AM'
    }]
  };
  const handleSendReply = () => {
    if (!reply.trim()) return;
    setLoading(true);
    setTimeout(() => {
      setReply('');
      setLoading(false);
      // In a real app, append message to thread
    }, 1000);
  };
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-24 flex flex-col" data-id="element-1827">
      <Header title={`Dispute #${dispute.id}`} showBack data-id="element-1828" />

      <div className="p-4 space-y-4 flex-1 overflow-y-auto" data-id="element-1829">
        {/* Dispute Header Card */}
        <div className="bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700" data-id="element-1830">
          <div className="flex justify-between items-start mb-4" data-id="element-1831">
            <div className="flex items-center gap-3" data-id="element-1832">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center ${dispute.priority === 'High' ? 'bg-red-100 text-red-600 dark:bg-red-900/30' : dispute.priority === 'Medium' ? 'bg-yellow-100 text-yellow-600 dark:bg-yellow-900/30' : 'bg-blue-100 text-blue-600 dark:bg-blue-900/30'}`} data-id="element-1833">
                <PackageX className="w-6 h-6" data-id="element-1834" />
              </div>
              <div data-id="element-1835">
                <h2 className="font-bold text-gray-900 dark:text-white" data-id="element-1836">
                  {dispute.reason}
                </h2>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1837">
                  Order #{dispute.orderId}
                </p>
              </div>
            </div>
            <div className="flex flex-col items-end gap-1" data-id="element-1838">
              <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase ${dispute.status === 'Resolved' ? 'bg-green-100 text-green-700 dark:bg-green-900/30' : dispute.status === 'In Progress' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30' : 'bg-orange-100 text-orange-700 dark:bg-orange-900/30'}`} data-id="element-1839">
                {dispute.status}
              </span>
              <span className="text-[10px] font-medium text-gray-500 dark:text-gray-400" data-id="element-1840">
                {dispute.date}
              </span>
            </div>
          </div>

          <div className="pt-3 border-t border-gray-100 dark:border-gray-700 flex justify-between items-center" data-id="element-1841">
            <div className="flex items-center gap-2" data-id="element-1842">
              <User className="w-4 h-4 text-gray-400" data-id="element-1843" />
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1844">
                {dispute.buyerName}
              </span>
            </div>
            <span className={`text-xs font-medium ${dispute.priority === 'High' ? 'text-red-500' : dispute.priority === 'Medium' ? 'text-yellow-500' : 'text-blue-500'}`} data-id="element-1845">
              {dispute.priority} Priority
            </span>
          </div>
        </div>

        {/* Conversation Thread */}
        <div className="space-y-4" data-id="element-1846">
          <h3 className="font-bold text-gray-900 dark:text-white px-1" data-id="element-1847">
            Conversation
          </h3>

          {dispute.messages.map(msg => {
          const isVendor = msg.sender === 'vendor';
          return <div key={msg.id} className={`flex gap-3 ${isVendor ? 'flex-row-reverse' : ''}`} data-id="element-1848">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${isVendor ? 'bg-primary/10 text-primary' : 'bg-gray-200 dark:bg-gray-700 text-gray-500'}`} data-id="element-1849">
                  {isVendor ? <Store className="w-4 h-4" data-id="element-1850" /> : <User className="w-4 h-4" data-id="element-1851" />}
                </div>
                <div className={`max-w-[80%] ${isVendor ? 'items-end' : 'items-start'} flex flex-col`} data-id="element-1852">
                  <span className="text-[10px] text-gray-500 dark:text-gray-400 mb-1 px-1" data-id="element-1853">
                    {msg.name} • {msg.time}
                  </span>
                  <div className={`p-3 rounded-2xl text-sm ${isVendor ? 'bg-primary text-white rounded-tr-none' : 'bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 text-gray-700 dark:text-gray-300 rounded-tl-none shadow-sm'}`} data-id="element-1854">
                    {msg.text}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>

      {/* Reply Area */}
      {dispute.status !== 'Resolved' && <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-700 p-4 pb-safe z-40" data-id="element-1855">
          <div className="flex gap-2 mb-3" data-id="element-1856">
            <Button variant="outline" className="flex-1 text-xs py-2 border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300" data-id="element-1857">
              Accept Return
            </Button>
            <Button variant="outline" className="flex-1 text-xs py-2 border-red-200 text-red-600 hover:bg-red-50 dark:border-red-900/30 dark:text-red-400 dark:hover:bg-red-900/10" data-id="element-1858">
              Escalate to Admin
            </Button>
          </div>
          <div className="flex items-end gap-2" data-id="element-1859">
            <div className="flex-1 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden" data-id="element-1860">
              <textarea value={reply} onChange={e => setReply(e.target.value)} placeholder="Type your response..." rows={1} className="w-full p-3 text-sm bg-transparent focus:outline-none dark:text-white resize-none max-h-24" style={{
            minHeight: '44px'
          }} data-id="element-1861" />
            </div>
            <button onClick={handleSendReply} disabled={!reply.trim() || loading} className="w-11 h-11 bg-primary text-white rounded-xl flex items-center justify-center shrink-0 disabled:opacity-50" data-id="element-1862">
              {loading ? <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-1863" /> : <Send className="w-5 h-5" data-id="element-1864" />}
            </button>
          </div>
        </div>}
    </div>;
}